export default __webpack_public_path__ + "static/media/ClientTalkingPoints.593d5d21.JPG";